import { mode } from '@chakra-ui/theme-tools';

// Tabs — active indicator uses brand.500; pill variant for card-internal tabs
export const tabsStyles = {
  components: {
    Tabs: {
      variants: {
        // Underline variant: slide indicator with smooth cubic-bezier motion
        line: props => ({
          tab: {
            fontSize: 'sm',
            fontWeight: 'medium',
            color: mode('gray.500', 'gray.400')(props),
            borderBottomWidth: '2px',
            borderBottomColor: 'transparent',
            // Smooth slide: animate border + color together
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
            _selected: {
              color: mode('brand.600', 'brand.300')(props),
              borderBottomColor: mode('brand.500', 'brand.400')(props),
              fontWeight: 'semibold',
            },
            _hover: {
              color: mode('gray.700', 'gray.200')(props),
              // Warm cream hover bg matches surface.raised
              bg: mode('rgba(250,250,247,0.80)', 'whiteAlpha.50')(props),
            },
            _focus: { boxShadow: 'none' },
          },
          tablist: {
            borderBottomWidth: '1px',
            borderBottomColor: mode('gray.200', 'whiteAlpha.200')(props),
          },
        }),
        // Pill variant: active pill gets emerald fill + soft shadow
        pill: props => ({
          tab: {
            fontSize: 'sm',
            fontWeight: 'medium',
            borderRadius: 'full',
            px: 4,
            py: 1,
            color: mode('gray.500', 'gray.400')(props),
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
            _selected: {
              color: mode('white', 'white')(props),
              bg: mode('brand.500', 'brand.500')(props),
              fontWeight: 'semibold',
              boxShadow: '0 4px 12px rgba(99,102,241,0.40), 0 1px 3px rgba(99,102,241,0.22)',
            },
            _hover: {
              color: mode('gray.700', 'gray.200')(props),
              bg: mode('brand.50', 'whiteAlpha.100')(props),
            },
            _focus: { boxShadow: 'none' },
          },
          tablist: {
            gap: 1,
            borderBottom: 'none',
            bg: mode('surface.sunken', 'whiteAlpha.50')(props),
            borderRadius: 'full',
            p: '3px',
          },
        }),
      },
      defaultProps: {
        variant: 'line',
      },
    },
  },
};
